document.addEventListener('alpine:init', function () {
  if (window.__ctrNotifyMeRegistered) return;
  window.__ctrNotifyMeRegistered = true;

  Alpine.store('ctrNotifyMe', {
    available: true,
    setAvailable: function (value) {
      this.available = !!value;
    },
  });

  Alpine.data('ctrNotifyMe', function (initialAvailable) {
    return {
      init: function () {
        this.$store.ctrNotifyMe.setAvailable(initialAvailable !== false);

        if (window.__ctrNotifyMeBound) return;
        window.__ctrNotifyMeBound = true;
        this.bindVariantListeners();
      },

      bindVariantListeners: function () {
        document.addEventListener('mozi:variant:change', function (event) {
          var variant = event.detail && event.detail.variant;
          if (!variant) {
            Alpine.store('ctrNotifyMe').setAvailable(false);
            return;
          }
          Alpine.store('ctrNotifyMe').setAvailable(variant.available);
        });
      },
    };
  });
});
